(function(){
  if(window.__lbInit)return;window.__lbInit=true;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var warmed={};
  function warm(src){if(!src||warmed[src])return;warmed[src]=1;var im=new Image();im.decoding='async';im.src=src;if(im.decode)im.decode().catch(function(){})}
  function stars(){
    document.querySelectorAll('[data-lb-stars]').forEach(function(el){
      if(el.dataset.done)return;el.dataset.done='1';
      var n=parseInt(el.getAttribute('data-lb-stars'),10)||60;
      for(var i=0;i<n;i++){
        var s=document.createElement('i');s.className='lb-star';
        var z=Math.random(),sz=z<.8?1.5:(z<.96?2.5:3.5);
        s.style.left=(Math.random()*100)+'%';s.style.top=(Math.random()*100)+'%';
        s.style.width=sz+'px';s.style.height=sz+'px';
        s.style.animationDelay=(-Math.random()*5)+'s';s.style.animationDuration=(2.5+Math.random()*3.5)+'s';
        el.appendChild(s);
      }
    });
  }
  function show(e){e.classList.add('is-in')}
  function reveal(){
    var els=[].slice.call(document.querySelectorAll('.lb-r:not(.is-in)'));
    if(reduce||!('IntersectionObserver' in window)){els.forEach(show);return}
    var vh=window.innerHeight||800,rest=[];
    els.forEach(function(e){if(e.getBoundingClientRect().top<vh*0.95){requestAnimationFrame(function(){show(e)})}else{rest.push(e)}});
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){show(e.target);io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px'});
    rest.forEach(function(e){io.observe(e)});
    var check=function(){document.querySelectorAll('.lb-r:not(.is-in)').forEach(function(e){if(e.getBoundingClientRect().top<(window.innerHeight||800)*0.92)show(e)})};
    window.addEventListener('scroll',check,{passive:true});
    setTimeout(check,2500);
  }
  function ready(img){return img&&img.complete&&img.naturalWidth>0}
  function moons(){
    document.querySelectorAll('[data-lb-cycle]').forEach(function(m){
      if(m.dataset.done)return;m.dataset.done='1';
      var sl=m.querySelectorAll('.lb-moon__slide'),cap=m.querySelector('[data-lb-cap]'),i=0;
      sl.forEach(function(s){var im=s.querySelector('img');if(im){im.loading='eager';warm(im.currentSrc||im.src)}});
      if(sl.length<2||reduce)return;
      setInterval(function(){
        if(document.hidden)return;
        var n=(i+1)%sl.length,tries=0;
        while(!ready(sl[n].querySelector('img'))&&tries<sl.length){n=(n+1)%sl.length;tries++}
        if(n===i)return;
        sl[i].classList.remove('is-on');i=n;sl[i].classList.add('is-on');
        if(cap)cap.textContent=sl[i].getAttribute('data-name');
      },2800);
    });
  }
  function pdpWarm(){
    document.querySelectorAll('[data-lb-json]').forEach(function(j){
      if(j.dataset.warm)return;j.dataset.warm='1';
      var go=function(){
        try{JSON.parse(j.textContent).forEach(function(v){warm(v.i)})}catch(e){}
        var r=j.closest('section');if(r)r.querySelectorAll('[data-thumb]').forEach(function(t){warm(t.getAttribute('data-thumb'))});
      };
      if(document.readyState==='complete')setTimeout(go,200);else window.addEventListener('load',function(){setTimeout(go,200)});
    });
  }
  function sticky(){
    document.querySelectorAll('[data-sticky]').forEach(function(st){
      if(st.dataset.done)return;st.dataset.done='1';
      var root=st.closest('section'),b=root&&root.querySelector('[data-add]'),add=st.querySelector('[data-sticky-add]');
      if(!b)return;
      var up=function(){var on=b.getBoundingClientRect().bottom<0;st.classList.toggle('is-on',on);if(add)add.tabIndex=on?0:-1};
      window.addEventListener('scroll',up,{passive:true});up();
    });
  }
  function init(){stars();reveal();moons();pdpWarm();sticky()}
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();
